/* eslint-disable react/prop-types */
// @flow

// Standard Pakete
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'

// hinzugefügte Pakete
import { Masthead } from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import { Waypoint } from 'react-waypoint'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import Footer from '@ta-interaktiv/react-footer'
import RunningRoute, {
  iconLeicht,
  iconLeichtSpiegelverkehrt,
  iconMittel,
  iconSchwer
} from '../../components/runningRoute'

// CSS
import './style.scss'

type Props = {
  articleId: string
}

const ADDITIONAL_SHARES = 1006

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '21438906'
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          inverted
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
        />
        <header
          className='ui vertical fitted segment'
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <Cover
            title='Die schönsten Joggingrouten von Zürich'
            subtitle='Für Anfänger und Fortgeschrittene: Wir haben für Sie zehn interessante Laufrouten der Stadt zusammengestellt.'
          />

          <Waypoint
            scrollableAncestor={window}
            onLeave={({ previousPosition, currentPosition }) => {
              const name = 'startReading'
              if (
                previousPosition === Waypoint.inside &&
                currentPosition === Waypoint.above
              ) {
                window.dataLayer = window.dataLayer || []
                if (!window.dataLayer.find(element => element.event === name)) {
                  window.dataLayer.push({ event: name })
                }
              }
            }}
          />

          <div className='ui very fitted vertical segment'>
            <div className='ui container'>
              <p className='ta secondary caption'>
                Zürichs Laufvielfalt erleben: Die Weite der Allmend Brunau, am
                See über die Quaibrücke, am Zürichhorn vorbei und im Seefeld dem
                Hornbach entlang.
              </p>
            </div>
          </div>
        </header>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <p className='ta author' style={{ paddingTop: '2em' }}>
              Von Emil Bischofberger und Patrick Vögeli
            </p>
            <p>
              Der Mensch ist ein Gewohnheitstier. Das gilt für jeden
              Lebensbereich, so auch beim Laufen. Darum laufen die, die
              regelmässig laufen, regelmässig die gleichen Routen. Das wollen
              wir ändern, und haben zur Inspiration die zehn schönsten Strecken
              der Stadt zusammengestellt. Manche sind altbekannt, manche
              ungewohnt. Probieren Sie sie aus. Und wenn Sie mit dem ankommenden
              Frühling mit dem Gedanken spielten, nun wieder einmal die
              Laufschuhe zu schnüren – noch besser: Wählen Sie eine der Routen
              und geniessen die neuen Eindrücke.
              <br />
              <br />
              Viel Spass!
            </p>

            <p className=''>&nbsp;</p>
            <p className=''>&nbsp;</p>
          </div>

          <RunningRoute
            routeTitle='1. Schönheit braucht keine Kreativität'
            routeSubtitle='Rund ums Seebecken'
            level='leicht'
            time='45–55 Minuten'
            distance='8,9 km'
            elevationGain='~0 Hm'
            start={
              <>
                <b>Start:</b> Bürkliplatz, Kreis 1
              </>
            }
            lng='8.54350'
            lat='47.35807'
            lngFirstCorner='8.555298'
            latFirstCorner='47.36723'
            lngLastCorner='8.53445'
            latLastCorner='47.34908'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.54111'
            markerPositionLat='47.36629'
            getStyle='leichtTrack'
            iconStart={iconLeicht}
            track={require('../main/track_seebecken.json')}
            text={
              <>
                Auf die Idee sind Sie auch schon gekommen. Aber das Seeufer ist
                zu schön, um hier ignoriert zu werden. Wir laufen erst zum
                Zürichhorn, den Blick immer mal wieder aufs Wasser richtend,
                zugleich den Spaziergängern ausweichend. Am Wendepunkt drehen
                wir eine Runde um die Skulptur von Tinguely, das wäre auch der
                Ort für ein Selfie. Zurück zum Bürkliplatz und Richtung
                Landiwiese. Auch dort wenden wir spielerisch: Mit einer Runde
                auf der Saffa-Insel. Wer noch Energie für zwei zusätzliche
                Kilometer hat, kann auch weiterlaufen. Der Seeuferweg bleibt
                abwechslungsreich, bis bei der Roten Fabrik und dem
                Cassiopeiasteg definitiv umgekehrt werden muss.
              </>
            }
          />

          <RunningRoute
            routeTitle='2. Grüne Runden im Verkehrsdickicht'
            routeSubtitle='Im Irchelpark'
            level='leicht'
            time='5–8 Minuten'
            distance='1,1 km (1 Runde)'
            elevationGain='6 Hm'
            start={
              <>
                <b>Start:</b> Irchelpark, Kreis 6
              </>
            }
            lng='8.54459'
            lat='47.39826'
            lngFirstCorner='8.54722'
            latFirstCorner='47.39954'
            lngLastCorner='8.54192'
            latLastCorner='47.39700'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.54311'
            markerPositionLat='47.39683'
            getStyle='leichtTrack'
            iconStart={iconLeicht}
            track={require('../main/track_irchelpark.json')}
            text={
              <>
                Mehr Verkehr als rund um den Irchelpark geht nicht. Und trotzdem
                ist der Strassenlärm nach einer halben Laufrunde ausgeblendet,
                kehrt Ruhe ein in diesem Grün inmitten des Verkehrsdickichts –
                der perfekte Ort für eine aktive Mittagspause. Die Finnenbahn
                ist der logische Startpunkt der Laufrunde. Doch diese kann von
                Runde zu Runde variiert werden. Mal nur um den kleinen Teich,
                dann wieder hoch bis zur Überdachung der rauschenden
                Strassenschneise. Wer hier weiterläuft, durchquert den Irchel
                Campus und wird nur Minuten später definitiv vom Grün
                verschluckt, jenem des Zürichberg-Waldes.
              </>
            }
          />

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '25ContentRead'
                })
              }
            }}
          />

          <RunningRoute
            routeTitle='3. Big City Life'
            routeSubtitle='Durch die hochwachsende Stadt'
            level='leicht'
            time='35–45 Minuten'
            distance='6,6 km'
            elevationGain='100 Hm'
            start={
              <>
                <b>Start:</b> Landesmuseum, Kreis 1
              </>
            }
            lng='8.52671'
            lat='47.38217'
            lngFirstCorner='8.51261'
            latFirstCorner='47.39346'
            lngLastCorner='8.54087'
            latLastCorner='47.37878'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.54064'
            markerPositionLat='47.37906'
            getStyle='leichtTrack'
            iconStart={iconLeicht}
            track={require('../main/track_limmat-gleisbogen.json')}
            text={
              <>
                Das Limmatufer ist eine logische Läufer-Destination. Hier ist es
                aber nur der Weg zum Filetstück des Laufs, dem Gleisbogen
                Zürich-West. Beim Ampèresteg wird der Fluss überquert, die rote
                Farbe der Brücke weist den Weg: zum roten Fuss- und Veloweg, der
                über die Gleisbogen-Passerelle führt, in einer lang gezogenen
                Linkskurve entlang den Gleisen bis zum Prime Tower. Nirgendwo
                fühlt sich Laufen in Zürich grossstädtischer an als hier, durchs
                in die Höhe wachsende Zürich-West. Vom höchsten Gebäude Zürichs
                führt die Route weiter Richtung Viadukt. Auf dem Gehweg über den
                Viaduktbögen geht es wieder Richtung Limmat und Platzspitz,
                zurück zum Start.
              </>
            }
          />

          <RunningRoute
            routeTitle='4. Miau!'
            routeSubtitle='Um den Katzen- und den Büsisee'
            level='leicht'
            time='40–50 Minuten'
            distance='7,8 km'
            elevationGain='77 Hm'
            start={
              <>
                <b>Start:</b> Bahnhof Affoltern ZH, Kreis 11
              </>
            }
            lng='8.49999'
            lat='47.42893'
            lngFirstCorner='8.51727'
            latFirstCorner='47.42052'
            lngLastCorner='8.48271'
            latLastCorner='47.43740'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.507548'
            markerPositionLat='47.421302'
            getStyle='leichtTrack'
            iconStart={iconLeichtSpiegelverkehrt}
            track={require('../main/track_chatzensee.json')}
            text={
              <>
                Das Wasser zieht den Läufer auch im Norden der Stadt an. Hier
                ist der Läufer-Dichtestress noch nicht ganz so akut – und die
                Stadt zugleich schon sehr weit weg. Gefühlt wie landschaftlich.
                Das macht auch den Reiz dieser Runde aus. Kein Wunder, bewegt
                man sich doch hier im Naturschutzgebiet. Die Stadtgrenze
                verläuft durch den Katzensee, der Läufer verlässt also während
                der Umrundung für einen Moment Zürich. Zurück geht es via
                Büsisee, dem kleinen Verwandten des Katzensees. Dieser entstand
                während des Baus der Autobahn – womit uns auch die Zivilisation
                wieder hat.
              </>
            }
          />

          <RunningRoute
            routeTitle='5. Meditatives Kreisen'
            routeSubtitle='Die rundeste Laufbahn der Stadt'
            level='leicht'
            time='1 bis viele Minuten'
            distance='0,25 km'
            elevationGain='0 Hm'
            start={
              <>
                <b>Start:</b> Rösliwiese, Kreis 6
              </>
            }
            lng='8.54285'
            lat='47.38779'
            lngFirstCorner='8.54336'
            latFirstCorner='47.38746'
            lngLastCorner='8.54230'
            latLastCorner='47.38814'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.543351'
            markerPositionLat='47.387614'
            getStyle='leichtTrack'
            iconStart={iconLeicht}
            track={require('../main/track_roesliwiese.json')}
            text={
              <>
                Während die meisten Läufer Rundbahnen wegen ihrer Monotonie
                meiden, ist genau dies für andere der Grund zu kreisen – die
                Beine bewegen sich wie von alleine, der Kopf kann abschweifen,
                weil keine Gefahr durch Wurzeln oder Verkehrsteilnehmer droht.
                Sechs offizielle Leichtathletik-Anlagen gibt es in Zürich. Die
                beliebteste ist das Sihlhölzli, wo zu jeder Tageszeit jemand
                seine 400-Meter-Runden abspult. Richtig meditativ wird das
                Laufen aber auf der siebten, inoffiziellen Anlage, jener auf der
                Rösliwiese: Weil auf dem Platz mitten im Quartier Unterstrass
                nicht Platz für zwei Geraden war, ist die Laufbahn praktisch
                kreisrund und misst nur 250 Meter. Nirgendwo drehen Beine und
                Gedanken synchroner.
              </>
            }
          />

          <RunningRoute
            routeTitle='6. Mühelos und gekühlt bergauf'
            routeSubtitle='Dem Wehrenbach entlang zur Trichtenhauser Mühle'
            level='mittel'
            time='40–50 Minuten'
            distance='8,6 km'
            elevationGain='167 Hm'
            start={
              <>
                <b>Start:</b> Botanischer Garten Zürich, Kreis 8
              </>
            }
            lng='8.5797'
            lat='47.35381'
            lngFirstCorner='8.5599'
            latFirstCorner='47.3595'
            lngLastCorner='8.60181'
            latLastCorner='47.35054'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.55808'
            markerPositionLat='47.35918'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            track={require('../main/track_trichterhauser_muehle.json')}
            text={
              <>
                Eigentlich sind uns Laufrunden am liebsten, bei denen wir nicht
                zwei Mal dieselbe Strecke zurücklegen. Bei Bächen und Flüssen
                machen wir eine Ausnahme, beim Weg entlang des Horn- und
                Wehrenbachs sowieso: Die Strecke nehmen wir bergauf und bergab
                sowieso komplett anders wahr. Bergauf bleibt genug Zeit, Wald
                und Bach zu betrachten. Nachdem wir beim grossen Mühlerad
                gewendet haben, geht es bergab deutlich schneller voran,
                entsprechend müssen wir mehr auf die nächsten Schritte als auf
                die Umgebung schauen – wenn gleich es nur wenige Wurzeln hat,
                die uns ins Stolpern bringen könnten.
                <br />
                Am Wildbach lassen sich alle Jahreszeiten erleben. Seinen
                grössten Trumpf spielt er aus, wenn es warm wird: Wald und Bach
                zusammen wirken dann wie eine Klimaanlage. Hier lässt sich im
                Hochsommer selbst mittags erträglich laufen.
              </>
            }
          />

          <RunningRoute
            routeTitle='7. Durch die Lünglein der Stadt'
            routeSubtitle='Von Park zu Park'
            level='mittel'
            time='40–50 Minuten'
            distance='7,5 km'
            elevationGain='60 Hm'
            start={
              <>
                <b>Start:</b> Gessnerbrücke, Kreis 1
              </>
            }
            lng='8.53163'
            lat='47.36573'
            lngFirstCorner='8.53585'
            latFirstCorner='47.37645'
            lngLastCorner='8.53505'
            latLastCorner='47.35505'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.53585'
            markerPositionLat='47.3763'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            track={require('../main/track_parkrun.json')}
            text={
              <>
                In Metropolen laufen die Einwohner in den «Lungen der Stadt» –
                den Pärken. Zürich kann keinen Hyde oder Central Park bieten.
                Hier sind die Ruheinseln deutlich kleiner – ein Versuch, einige
                laufend zu verbinden. Der Einstieg ist überraschend: Bei der
                Gessnerbrücke steigen wir bei der Rio-Bar die Treppe hinunter
                zum Schanzengraben – und laufen am Wasser der Stadthektik davon.
                Der Kanal führte direkt zum Seeufer, doch es lockt ein Abstecher
                zum Alten Botanischen Garten. Hier tief einatmen. Dann zum See,
                dort rechts. Die Unterführung beim Strandbad Mythenquai führt
                uns in den Belvoirpark. Der Weg steigt nun, bis wir im
                Rieterpark den höchsten Punkt der Runde erreichen, inklusive
                grossem Ausblick auf See und Bergpanorama. Auf dem Rückweg
                queren wir die Kloppstockwiese, die ebenfalls als Pärkchen
                durchgeht. Von da geht es hinunter zur Sihl, am Fluss entlang
                zurück zum Start.
              </>
            }
          />

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '75ContentRead'
                })
              }
            }}
          />

          <RunningRoute
            routeTitle='8. Seltene Tiere statt bellende Hunde'
            routeSubtitle='Eine ungewohnte Schlaufe an der Sihl'
            level='mittel'
            time='30–40 Minuten'
            distance='6,2 km'
            elevationGain='130 Hm'
            start={
              <>
                <b>Start:</b> Sihlcity, Kreis 3
              </>
            }
            lng='8.51782'
            lat='47.35075'
            lngFirstCorner='8.52482'
            latFirstCorner='47.36032'
            lngLastCorner='8.51055'
            latLastCorner='47.34107'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.52312'
            markerPositionLat='47.35992'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            track={require('../main/track_seltene_tiere.json')}
            text={
              <>
                Die Sihl lockt die Hündeler und Läufer in gleichem Masse an. Den
                grossen Hundemeuten weichen wir auf dieser Route aus. Eingangs
                Allmend laden die Hundebesitzer ihre Vierbeiner aus den Autos.
                Wir öffnen das Tor zum Eisvogelweg. Auf der offenen Grünfläche
                zwischen Autobahn und Sihl sind nur Zweibeiner gestattet: Vögel
                und wir. Einen Eisvogel treffen wir auf der Runde nicht an,
                dafür eine Reihe kreativer Wegnamen: Nachdem wir die Sihl
                überquert haben, folgen Blindschleichen- und Feuersalamanderweg,
                bergauf geht es auf dem Höcklerweg, wo wir auf dem Gänzilooweg
                zum Wald unterhalb des Albisgüetli gelangen, von wo wir zurück
                zum Sihlcity rollen.
              </>
            }
          />

          <RunningRoute
            routeTitle='9. Rauf und runter'
            routeSubtitle='Auf den Uetliberg'
            level='anspruchsvoll'
            time='70–80 Minuten'
            distance='12,6 km'
            elevationGain='530 Hm'
            start={
              <>
                <b>Start:</b> Triemli, Kreis 3
              </>
            }
            lng='8.49613'
            lat='47.35265'
            lngFirstCorner='8.51129'
            latFirstCorner='47.33737'
            lngLastCorner='8.48125'
            latLastCorner='47.36775'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.49508'
            markerPositionLat='47.36769'
            getStyle='schwerTrack'
            iconStart={iconSchwer}
            track={require('../main/track_uetli.json')}
            text={
              <>
                Auf einer Laufrunde sollte der Weg das Ziel sein. Doch es gibt
                Ausnahmen: Wer die Aussicht vom Uetliberg will, muss sich diese
                verdienen. Das geht nicht ohne einige Schweissperlen. Es führen
                viele Wege auf den höchsten Punkt der Stadt. Wir nehmen den
                Höcklerweg, weil der Weg hier etwas weniger steil hochführt als
                etwa beim Laternenweg, der kürzer wäre. Wer schon einige
                Kilometer in den Beinen hat, kann hier durchaus versuchen, auch
                bergauf noch im Laufschritt voranzukommen, bei der direkten
                Variante kommen höchstens professionelle Bergläufer auf diese
                Idee. Auch vom Berg runter führen viele Wege. Wir suchen erneut
                einen, der nicht ganz so steil abfällt, und rollen locker zurück
                zum Triemli.
              </>
            }
          />

          <RunningRoute
            routeTitle='10. Auf dem offiziellen Waldpfad'
            routeSubtitle='Der Klassiker Fichtentritt'
            level='anspruchsvoll'
            time='40–55 Minuten'
            distance='8,6 km'
            elevationGain='240 Hm'
            start={
              <>
                <b>Start:</b> Fichtentritt, Kreis 9
              </>
            }
            lng='8.46182'
            lat='47.38217'
            lngFirstCorner='8.47427'
            latFirstCorner='47.37479'
            lngLastCorner='8.44912'
            latLastCorner='47.38985'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.47194'
            markerPositionLat='47.38176'
            getStyle='schwerTrack'
            iconStart={iconSchwer}
            track={require('../main/track_fichtentritt.json')}
            text={
              <>
                Beim Stichwort «Waldlaufstrecke» geht sogleich das Kopfkino los:
                Da sind Baumwoll-Trainerhosen, ein Frotteestirnband und
                Laufschuhe, die heute als retro durchgehen. Kein Wunder: Die
                meisten dieser Strecken wurden in den 1970er- und 80er-Jahren
                eingerichtet. Auch der Fichtentritt, ein Klassiker auf dem
                Stadtgebiet. Die Laufrunde bringt eine Erkenntnis: Die sehr
                coupierte Waldrunde ist eine echte Herausforderung für den
                Hobbyläufer, der sonst höhenmeterfrei den Flüssen und Gewässern
                entlangläuft. Aber die Anstrengung lohnt sich: Was gibt es
                Besseres, als die Lungen mit frischer Waldluft zu fluten?
              </>
            }
          />
          <div className="note-wrapper">
            <div className="note">Dieser Artikel erschien erstmals am <nobr>20. April 2019.</nobr> Wir publizieren ihn hier nochmals in aktualisierter Form.</div>
          </div>
        </div>

        <Footer
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
          credits={[
            ['Digitale Umsetzung', 'Patrick Vögeli, Interaktiv-Team'],
            ['Text und Recherche', 'Emil Bischofberger']
          ]}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
